export const USER_LOGIN = "/login";
export const FORGOT_PASSWORD = "/forgetPassword";
export const SEND_OTP = "/forgetPassword";
export const VERIFY_OTP = "/verifyOtp";
export const RESET_PASSWORD = "/resetPassword";
export const GET_PROJECTS = "/project";
export const GET_PROJECT_BY_ID = "/project";
export const ADD_PROJECT = "/project";
export const GET_WORKERS = "/user/worker";
export const ADD_WORKER = "/worker";
export const GET_TASKS = "/task";
export const CREATE_TASK = "/task";
export const PROJECT_ALLOCATE = "/project_allocation";
export const GET_EXPENSES = "/expense";
// Expense CRUD uses the same base path
export const GET_WORKER_PROGRESS = "/worker_progress/";
export const GET_WORKER_STATS = "/worker/stats";
export const GET_ALL_CLIENTS = "/user/client";
export const GET_WORKER_BY_ID = "/user/details";
export const DELETE_WORKER = "/user/worker";
export const GET_TASKS_BY_PROJECT = "/task";
export const GET_PROJECT_WORKERS = "/project/worker";
export const GET_WORKERS_PROJECTS = "/project_allocation/worker";
export const UPDATE_PROJECT_STATUS = "/projectStatus";
export const GET_VENDOR = "/vendor";
export const CREATE_VENDOR = "/vendor";
export const DELETE_VENDOR = "/vendor";
export const GET_VENDOR_BY_ID = "/vendor";

///Mahz
export const GET_USERS_POSTS = "user/post/own";
export const GET_ALL_POSTS = "/posts";
export const GET_TIME_FOR_POSTS = "user/timeposts?timeframe=month";
export const GET_POST_BY_ID = "user/post";   
export const SEARCH_POSTS = "user/search/posts";         
export const SEARCH_COMMUNITY = "search/community";        
export const GET_USER_EVENT = "user/event";
export const EDIT_UNIVERSITY = "university/update";
export const DELETE_UNIVERSITY = "university/delete";
export const DELETE_EVENT = "/delete/Event";
export const DELTE_EVENT_HOST = "/user/removeEventHost";
export const EDIT_EVENT = "update/Event";
export const DELETE_POST = "/user/delete";
export const GET_STORIES = "/user/stories";
//export const GET_STORIES="/admin/stories"
export const ALL_COMMUNITIES = "/allcommunities";
export const OFFICIAL_COMMUNITY = "/getOfficialCommunity";
export const CUSTOM_COMMUNITY = "/allcommunities?isAnonymous=false";
export const WITHDRAWAL_REQUESTS = "/getadminrequests";
export const GET_USER = "/user/all";
export const USER_CHANGE_STATUS = "user/status";
export const BOOSTED_POST = "user/boost/posts";
export const BOOSTED_EVENT = "/boost/event";
export const BOOSTED_STORIES = "/admin/boost/stories";
export const DELETE_STORY = "/delete/story";
export const DELETE_COMMUNITY = "/delete";
export const EDIT_COMMUNITY = "update";

//Search User
export const SEACRH_USER = "/user/adminSearch";
export const SEACRH_STORIES = "/searchGroup";

//Get User detail
// export const GET_USER_PROFILE = "user/detail";
export const GET_USER_PROFILE = "user/getUserAndQuestion";
//Edit User
export const UPDATE_USER_PROFILE = "user/updateUserProfile";
//delete Question
export const DELETE_QUESTION = "/question";
export const DELETE_COMMENTS = "/post/comment/delete";
//get comments
export const GET_COMMENTS = "post/Comment";
//User Likes
export const USER_LIKES = "likesCount";
//Moderations
export const MODERATIONS_POSTS = "getpostreports";
export const MODERATIONS_USERS = "getuserreports";
export const MODERATIONS_STORIES = "getstoryreports";
export const MODERATIONS_QUESTIONS = "getquestionreports";
export const MODERATIONS_COMMENTS = "getcommentreports";
export const MODERATIONS_COMMUNITTIES = "getcommunityreports";
export const MODERATIONS_EVENTS = "geteventreports";
export const MODERATIONS_POSTS_DELETE = "deletepostreport";
export const MODERATIONS_STORIES_DELETE = "deletestoryreport";
export const MODERATIONS_QUESTION_DELETE = "deletequestionreport";
export const MODERATIONS_COMMENT_DELETE = "deletecommentreport";
export const MODERATIONS_EVENT_DELETE = "deleteeventreport";
export const MODERATIONS_USER_DELETE = "deleteuserreport";
export const MODERATIONS_COMMUNITY_DELETE = "deletecommunityreport";
export const MODERATIONS_REPORT_DETAILS = "getreportdetails";
export const STATS_REPORT = "getreportcount";
export const ACCOUNT_APPROVAL = "approve";
export const DASH_COUNT = "dashcount";
export const DASH_COMMUNITY = "commdash";
export const GET_USER_POSTS = "user/post/own";
export const GET_USER_FRIENDS = "getuserfriends";

//Get Boost
export const GET_BOOSTS = "getboost";

// Withdrawal Requests

export const UPLOAD_WITHDRAWAL_REQUEST_RECEIPT = "/updatestatus";

//
// export const GET_ALL_QUESTIONS = "";
// export const GET_ALL_COMMUNITIES = "";
// export const GET_ALL_COMMENTS = "";

// export const SEARCH_QUESTIONS = "/moderations/questions";
// export const SEARCH_COMMUNITIES = "/moderations/communities";
// export const SEARCH_COMMENTS = "/moderations/comments";

// Add this with other endpoints
export const SEND_PROGRESS = "/manager/send_progress";

export const ADD_PROGRESS_COMMENT = "/progress/add_comment";

// Add these new endpoints
export const ADD_ATTACHMENT_COMMENT = "/progress/attachment/add_comment";
export const GET_ATTACHMENT_COMMENTS = "/progress/attachment/get_comments";

export const GET_WORKER_DETAIL = "/worker/detail";

// Add this with other endpoints
export const UPDATE_TASK = "/task";

// Add with other endpoints
export const DELETE_TASK = "/task";

export const EDIT_PROGRESS_COMMENT = "/progress/edit_comment";
export const DELETE_PROGRESS_COMMENT = "/progress/delete_comment";

export const EDIT_ATTACHMENT_COMMENT = "/progress/attachment/edit_comment";
export const DELETE_ATTACHMENT_COMMENT = "/progress/attachment/delete_comment";

// Add these new endpoints
export const CREATE_CLIENT = "/client";
export const UPDATE_CLIENT = "/client";

// Add this new endpoint
export const GET_CLIENT_DETAIL = "/user/client";
// Add delete client endpoint
export const DELETE_CLIENT = "/user/client";

// Add this with other endpoints
export const GET_DASHBOARD = "/manager/dashboard";

// Add this new endpoint
export const LIKE_COMMENT = "/like";

// Add this new endpoint
export const GET_ORGANIZATION = "/organization";

// Add these new endpoints
export const CREATE_MANAGER = "/manager";
export const UPDATE_MANAGER = "/manager"; // ID will be appended in service
export const DELETE_MANAGER = "/user/manager"; // ID will be appended in service
// Managers listing
export const GET_MANAGERS = "/user/manager";
export const UPDATE_MANAGER_STATUS = "/manager/status";

export const DELETE_PROJECT = "/project";

// Reports
export const REPORTS_WORKER_DATA = "/reports/worker-data";

// Super Admin Dashboard
export const GET_SUPER_ADMIN_DASHBOARD = "/super-admin/dashboard";
export const GET_ALL_PROJECTS_SUPER_ADMIN = "/all-projects";
export const GET_ALL_ORGANIZATIONS = "/organizations";
export const GET_TOP_ORGANIZATIONS = "/organizations/top";
export const GET_ALL_MANAGERS_SUPER_ADMIN = "/all-managers";
export const GET_ALL_WORKERS_SUPER_ADMIN = "/all-workers";
export const GET_ACTIVE_PROJECTS = "/super-admin/active-projects";
export const GET_ACTIVE_ORGANIZATIONS = "/super-admin/active-organizations";
export const GET_SUBSCRIPTION_STATS = "/subscription-stats";

// Super Admin Project Management
export const ASSIGN_CLIENT_TO_PROJECT = "/project/assign-client";
export const REMOVE_CLIENT_FROM_PROJECT = "/project/remove-client";

// Super Admin Organization Management
export const CREATE_ORGANIZATION_MANAGER = "/create-organization-manager";
export const UPDATE_ORGANIZATION_PLAN = "/update-plan";
export const ACTIVATE_ORGANIZATION = "/activate";
export const DEACTIVATE_ORGANIZATION = "/deactivate";
export const DELETE_ORGANIZATION = "/organization";
